import { format } from 'date-fns';
import type {
  Filters,
} from 'hooks/store/invoices/use-invoices-tracking-search-params';
import type { FormSchema } from './form-schema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createFilters = (formData: FormSchema): Filters => {
  const { emissionDate, deadlineDate, ...rest } = formData;

  return {
    ...rest,
    ...(emissionDate?.from && { emissionDateFrom: f(emissionDate.from) }),
    ...(emissionDate?.to && { emissionDateTo: f(emissionDate.to) }),
    ...(deadlineDate && { deadlineDate: f(deadlineDate) }),
  };
};